import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
  },
  action
) {
  switch (action.type) {
    case homeConstants.PLAY_STORE_REQUEST:
      return {
        ...state,
        data: {},
        isProgress: true,
      };
    case homeConstants.PLAY_STORE_SUCCESS:
      return {
        ...state,
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.PLAY_STORE_FAILURE:
      return {
        ...state,
        error: action.error,
        data: {},
        isProgress: false,
      };
    default:
      return state;
  }
}
